module.exports = __webpack_public_path__ + "assets/f726a495a79eb5bfda865a8151c8c669.mp3";